export const DEFAULT_COLOR_THEME = '#000000';
